export default "__VITE_ASSET__PIqOj4ON__"